import { render, staticRenderFns } from "./InventoryAdvancePaymentApprovedStateCardActions.vue?vue&type=template&id=4f64d048&"
import script from "./InventoryAdvancePaymentApprovedStateCardActions.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentApprovedStateCardActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports